<template>
  <div id="app">
    <topcomponents></topcomponents>
    <main class="cd-main-content">
      <router-view />
      <!-- <webBottomcomponents></webBottomcomponents> -->
    </main>
  </div>
</template>

<script>
import topcomponents from "@/components/webTop/webTopMenu";
import webBottomcomponents from "@/components/webBottom/webBottom";
export default {
  name: "App",
  components: {
    topcomponents,
    webBottomcomponents,
    show: true,
  },
  watch: {
    $route(to, from) {
      console.log(to.name);
      //alert(to.name);

    },
  },

};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue